<template>
  <div>
    <div class="mt-2">
      <naj-search-box
        :type-id="formFieldType.number"
        :placeholder="local.home.tabCommon.filterWithCaseCode"
        :search.sync="searchQuery.caseCode"
        @filterDataClicked="filterData()"
        @showFilterClicked="toggleFilter()"
      ></naj-search-box>
    </div>
    <div v-if="hasFilter" class="filter-row-wrapper d-flex mt-3">
      <div class="col-12">
        <template v-for="filter in filters">
          <span v-if="searchQuery[filter.name]" :key="filter.name" class="ma-1">
            <v-chip
              :key="filter.name"
              :input-value="searchQuery[filter.name]"
              color="#F7FBFB"
              close
              outlined
              @click:close="
                searchQuery[filter.name] = null;
                filterData();
              "
            >
              <strong class="text-primary">{{
                filter.label + ':' + (searchQuery[filter.name + 'DisplayName'] || searchQuery[filter.name])
              }}</strong>
            </v-chip>
          </span>
        </template>
      </div>
    </div>
    <v-row class="mt-7">
      <v-col :cols="showFilter ? 9 : 12">
        <!-- TODO : items-per-page should be updated after najiz shutdown (20 for case + 20 for icms)-->
        <naj-item-table
          :data-items="data.list"
          :headers="headers"
          :pagination="pagination"
          :loading="loading"
          :items-per-page="20"
          :server-items-length="pagination.totalCount"
          :enable-expand="true"
          @update:page="onPageChange"
          @expandSlot="getUpdates"
        >
          <template slot="action" slot-scope="{ item }">
            <div class="mx-4">
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">
                    mdi-dots-vertical
                  </v-icon>
                  <v-icon v-if="item.proceduresCount > 0" class="notification-point">
                    mdi-checkbox-blank-circle
                  </v-icon>
                </template>
                <v-list>
                  <v-list-item>
                    <v-list-item-title>
                      <router-link :to="`/cases/case-file/${item.isPega}/${item.objectKey}`">
                        <naj-button text type="button" size="small">
                          {{ local.common.show }}
                        </naj-button>
                      </router-link>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title>
                      <naj-button text type="button" size="small" @click="openCancelArchiveModal(item, updateItem(item))">
                        {{ local.caseFile.archiveTheCase.cancelArchiving }}
                      </naj-button>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </template>

          <template slot="expandSlot" slot-scope="{ item }">
            <v-row>
              <v-col cols="12">
                <span class="header-text text-h5">
                  {{ local.home.tabCommon.latestUpdates }}
                </span>
                <naj-no-data
                  :has-data="item.updates && item.updates.hasUpdates"
                  :loading="item.isLoading"
                  :no-data-message="local.home.noUpdates"
                ></naj-no-data>
              </v-col>
              <template v-if="item.updates && !item.isLoading">
                <v-col v-if="item.updates.judgement" cols="3">
                  <judgement-card
                    :judgement="item.updates.judgement"
                    :case-object-key="item.objectKey"
                    :is-pega="item.isPega"
                  ></judgement-card>
                </v-col>
                <v-col v-if="item.updates.request" cols="3">
                  <request-card :request="item.updates.request" :is-pega="item.isPega"></request-card>
                </v-col>
                <v-col v-if="item.updates.decision" cols="3">
                  <decision-card :decision="item.updates.decision"></decision-card>
                </v-col>
              </template>
            </v-row>
          </template>
        </naj-item-table>
      </v-col>
      <v-col v-if="showFilter" cols="3">
        <v-card color="pa-3">
          <v-row>
            <v-col class="pt-0">
              <div class="text-left">
                <v-icon class="icon" @click="toggleFilter()">
                  mdi-close
                </v-icon>
              </div>
              <div class="text-h4 font-weight-bold">
                {{ local.common.filter }}
              </div>
            </v-col>
            <v-col v-for="filter in filters" :key="filter.name" cols="12">
              <naj-input
                :type-id="filter.typeId"
                :label="filter.label"
                :value.sync="searchQuery[filter.name]"
                :value-name.sync="searchQuery[filter.name + 'DisplayName']"
                :items="filter.items"
                item-text="name"
                item-value="id"
              ></naj-input>
            </v-col>

            <v-col cols="12" class="text-center">
              <naj-button :loading="loading" @click="filterData()">
                {{ local.common.filter }}
              </naj-button>

              <naj-button outlined @click="toggleFilter()">
                {{ local.common.close }}
              </naj-button>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <naj-confirmation
      :show-modal="showArchiveModal"
      :max-width="1000"
      :is-persistent="true"
      :no-header="true"
      :ok-btn-label="local.otp.acceptAndContinue"
      :close-btn-label="local.common.back"
      @ok="showArchiveTheCaseOTPModal()"
      @cancel="closeArchiveModal"
    >
      <template slot="message-content">
        <v-row>
          <v-col>
            <span class="header-title">{{ local.home.upcomingSessions.termsAndConditions }}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div>
              <h5>
                {{ local.caseFile.archivingTheCaseForNonOriginalParties.unarchiveTitle }}
              </h5>
            </div>
            <div class="details-condition">
              <h5 class="details-condition">
                {{ local.caseFile.archivingTheCaseForNonOriginalParties.showCase }}
              </h5>
            </div>
          </v-col>
        </v-row>
      </template>
    </naj-confirmation>

    <div v-if="viewNafathOtp">
      <naj-nafath-otp-input
        ref="nafathmodal"
        :route="local.otp.title"
        :show-modal="viewNafathOtp"
        :identity-number="userInfo.socialId"
        :service-type="nafathServiceTypes.archivingTheCase"
        @onCancelModal="viewNafathOtp = false"
        @authenticationSuccess="otpConfirmationHandler"
      >
      </naj-nafath-otp-input>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapCasesActions } = createNamespacedHelpers('CasesModule');
import DecisionCard from '../cards/decision-card.vue';
import RequestCard from '../cards/request-card.vue';
import JudgementCard from '../cards/judgement-card.vue';
const { mapState: mapLUTState, mapActions: mapLUTActions } = createNamespacedHelpers('LookupsModule');
const { mapActions: mapGlobalActions } = createNamespacedHelpers('GlobalModule');

import { toHijriDate, truncateText } from '@/helpers/utils';
import { userType, archiveActions, otpServiceId, nafathServiceTypes } from '@/helpers/enum';

export default {
  name: 'ArchivedCasesTab',
  components: {
    DecisionCard,
    RequestCard,
    JudgementCard,
  },
  props: {
    userInfo: {
      type: Object,
      required: true,
    },
    itemsPerPage: {
      default: 10,
      type: Number,
      required: false,
    },
    noDataText: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      searchQuery: {
        courtId: null,
        fromCaseDate: null,
        toCaseDate: null,
        caseTypeId: null,
      },
      loading: false,
      caseObjectKey: null,
      viewNafathOtp: false,
      showArchiveModal: false,
      archiveAction: null,
      userType,
      showFilter: false,
      otpErrorMessage: '',

      data: { list: [] },
      pagination: {
        pageSize: 20,
        pageIndex: 0,
        totalCount: 0,
        totalPages: 0,
        hasPreviousPage: false,
        hasNextPage: false,
      },
      headers: [
        {
          value: 'caseCode',
          text: this.local.home.tabCommon.caseCode,
          to: (item) => {
            return {
              name: 'case-file',
              params: {
                caseObjectKey: item.objectKey,
                isPega: String(item.isPega),
              },
            };
          },
          class: 'caseCode-header',
        },
        {
          value: 'caseDate',
          text: this.local.home.tabCommon.caseDate,
          formatter: toHijriDate,
          tooltipMode: this.tooltipMode.formatter,
        },
        {
          value: 'caseTypeName',
          text: this.local.home.tabCommon.caseType,
          formatter: truncateText,
        },
        {
          value: 'roleInCase',
          text: this.local.home.tabCommon.roleInCase,
        },
        {
          value: 'prosecutorName',
          text: this.local.home.tabCommon.prosecutorName,
          formatter: truncateText,
          tooltipMode: this.tooltipMode.normal,
        },
        {
          value: 'defendantName',
          text: this.local.home.tabCommon.defendantName,
          formatter: truncateText,
          tooltipMode: this.tooltipMode.normal,
        },
        {
          value: 'caseStatusName',
          text: this.local.home.tabCommon.status,
        },
        {
          value: 'action',
          class: 'action-item justify-content-center',
          isCustomTemplate: true,
        },
      ],
      archiveActions,
      otpServiceId,
      cancelArchiveRequest: {
        key: null,
        caseObjectKey: null,
        partyId: null,
      },
      otpConfirmationHandler: () => {},
      isVerified: false,
      nafathServiceTypes,
    };
  },
  computed: {
    ...mapLUTState(['courts', 'allCaseTypes', 'portalPartyRoles']),
    hasFilter() {
      return (
        this.searchQuery.courtId ||
        this.searchQuery.fromCaseDate ||
        this.searchQuery.toCaseDate ||
        this.searchQuery.roleInCase ||
        this.searchQuery.caseTypeId
      );
    },
    filters() {
      return [
        this.mapFilterItem('courtId', 'court', 'selectbox', this.courts),
        this.mapFilterItem('caseTypeId', 'caseType', 'selectbox', this.allCaseTypes),
        this.filterRoleInCase(),
        this.mapFilterItem('fromCaseDate', 'fromDate', 'date'),
        this.mapFilterItem('toCaseDate', 'toDate', 'date'),
      ];
    },
    computedSearchQuery() {
      return Object.assign({}, this.searchQuery);
    },
  },
  watch: {
    computedSearchQuery: {
      deep: true,
      handler(newValue, oldValue) {
        const oldValueString = JSON.stringify({
          ...oldValue,
          caseCode: null,
        });
        const newValueString = JSON.stringify({
          ...newValue,
          caseCode: null,
        });
        const isChanged = oldValueString != newValueString;
        if (isChanged) {
          this.filterData();
        }
      },
    },
  },
  mounted() {
    this.$emit('updateTabCount', 0);
    this.viewNafathOtp = true;
    this.otpConfirmationHandler = this.confirmationOpenPage;
  },
  methods: {
    ...mapGlobalActions(['getUserInfo']),
    filterRoleInCase() {
      if (this.userInfo.userType !== this.userType.najizLawyer) {
        let filteredPartyRoles = this.portalPartyRoles;

        return this.mapFilterItem('roleInCase', 'roleInCase', 'selectbox', filteredPartyRoles);
      } else return '';
    },
    mapFilterItem(name, key, typeId, items = []) {
      return {
        name: name,
        label: this.local.home.filter[key],
        typeId: this.formFieldType[typeId],
        items,
      };
    },
    toggleFilter() {
      this.showFilter = !this.showFilter;
    },
    ...mapLUTActions(['getCourts', 'getAllCaseTypes', 'getPortalPartyRoles']),
    ...mapCasesActions([
      'getCaseUpdates',
      'validateCaseLawsuitReplyIssuance',
      'archiveTheCase',
      'cancelArchivingTheCase',
      'getMyArchivedCases',
    ]),
    init() {
      this.loadData();
      this.getCourts();
      this.getAllCaseTypes();
      this.getPortalPartyRoles();
    },
    loadData() {
      if (this.isVerified == true) {
        this.loading = true;
        this.getMyArchivedCases({
          ...this.searchQuery,
          ...this.pagination,
        })
          .then(({ data }) => {
            this.loading = false;
            this.data = { ...data };
            this.pagination = {
              pageIndex: data.pageIndex,
              pageSize: data.pageSize,
              totalCount: data.totalCount,
              totalPages: data.totalPages,
              hasPreviousPage: data.hasPreviousPage,
              hasNextPage: data.hasNextPage,
            };
          })
          .finally(() => {
            this.loading = false;
            this.$emit('updateTabCount', this.pagination.totalCount);
          });
      }
    },
    filterData() {
      this.pagination.pageIndex = 0;
      this.loadData();
    },
    onPageChange(pageIndex) {
      this.pagination.pageIndex = pageIndex - 1;
      this.loadData();
    },
    getUpdates(caseInfo, index) {
      this.$set(this.data.list[index], 'isLoading', true);
      this.getCaseUpdates({
        isPega: caseInfo.isPega,
        objectKey: caseInfo.objectKey,
      })
        .then(({ data }) => {
          this.$set(this.data.list[index], 'updates', data);
        })
        .finally(() => {
          this.$set(this.data.list[index], 'isLoading', false);
        });
    },

    closeArchiveModal() {
      this.showArchiveModal = false;
    },
    openCancelArchiveModal(caseItem) {
      this.cancelArchiveRequest.caseObjectKey = caseItem.objectKey;
      this.cancelArchiveRequest.itemIdentifier = caseItem.caseCode;
      this.cancelArchiveRequest.partyId = caseItem.partyId;
      this.cancelArchiveRequest.ServiceId = otpServiceId.unArchiveCase;
      this.showArchiveModal = true;
      this.otpConfirmationHandler = this.cancelArchiving;
    },

    showArchiveTheCaseOTPModal() {
      this.showArchiveModal = false;
      this.viewNafathOtp = true;
    },
    confirmationOpenPage() {
      this.closeArchiveModal();
      this.toaster.success(this.local.common.verificationSucceeded);
      this.isVerified = true;
      this.init();
      this.cancelArchiveRequest.key = null;
      this.cancelArchiveRequest.caseObjectKey = null;
      this.cancelArchiveRequest.partyId = null;
      this.viewNafathOtp = false;
    },
    confirmation() {
      this.loading = true;
      this.viewNafathOtp = false;
      this.cancelArchiving();
    },
    cancelArchiving() {
      this.cancelArchivingTheCase(this.cancelArchiveRequest)
        .then((res) => {
          if (res.data.data) {
            this.searchQuery.caseCode = null;
            this.pagination.pageIndex = 0;
            this.archiveAction = archiveActions.canArchiveTheCase;
            this.loadData();
            this.toaster.success(res.data.message);
            this.cancelArchiveRequest.key = null;
            this.cancelArchiveRequest.caseObjectKey = null;
            this.cancelArchiveRequest.partyId = null;
            this.$emit('canDisplayArchivedCasesTab');
            this.$emit('loadData');
          }
        })
        .finally(() => (this.loading = false));
    },
    updateItem(item) {
      if (this.archiveAction != null && this.caseObjectKey == item.objectKey) {
        return this.archiveAction;
      } else {
        return item.archiveAction;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .naj-box-header-title {
  text-align: center;
  font-weight: bold;
}

::v-deep .List__empty {
  margin-top: 0px !important;
}

::v-deep .info-item-box .info-item-details:nth-child(2) {
  background: var(--app-light-secondary-color) 0% 0% no-repeat padding-box;
}

::v-deep .action-item {
  justify-content: flex-end;
}

::v-deep .empty {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  padding: 0 !important;

  .empty-title {
    font-size: 20px;
    line-height: 43px;
    margin: 0;
  }
}

.header-text {
  font-weight: 700;
  font-size: 18px;
  color: var(--app-dark-primary-color);
}

.filter-row-wrapper {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 10px 30px #d1d5df80;
}

::v-deep .v-chip.v-chip--outlined.v-chip.v-chip {
  background-color: #f7fbfb !important;
  border: 1px solid var(--app-primary-color) !important;
  border-radius: unset;

  .v-chip__content {
    button {
      color: var(--app-primary-color);
    }
  }
}

::v-deep .info-item-details.caseCode-header {
  .info-item-details-value {
    font-size: 24px;
  }
}

.details-condition {
  line-height: 1.8;
  text-indent: 5px;
}

.header-title {
  font-size: 22px;
  font-weight: bold;
  color: var(--app-primary-color);
}

.notification-point {
  color: var(--app-error-color);
  width: 0;
  height: 0;
  font-size: 6px;
  position: relative;
  left: 22px;
  top: -10px;
}
</style>
